module.exports = __webpack_public_path__ + "static/media/rewardsSnap.9012281f.png";